<div class="p-grid">
  <div class="p-field p-col-12">
    <label>Código de empresa</label>
    <div class="p-inputgroup">
      <input pInputText [(ngModel)]="integration.configuration.company_code" [placeholder]="'Ejemplo: 9999'" />
    </div>
  </div>

  <div class="p-col-12">
    <p-checkbox label="Exportar clientes a SAGE" [(ngModel)]="integration.configuration.export_clients" binary="true" name="export_clients" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <div class="p-col-6">
    <p-checkbox label="Importar clientes de SAGE" [(ngModel)]="integration.configuration.import_clients" binary="true" name="import_clients" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>
  <div class="p-col-6">
    <p-checkbox *ngIf="integration.configuration.import_clients" label="Importar saldo de SAGE" [(ngModel)]="integration.configuration.import_clients_totals" binary="true" name="import_articles" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <div class="p-col-6">
    <p-checkbox label="Exportar contactos a SAGE" [(ngModel)]="integration.configuration.export_contacts_clients" binary="true" name="export_contacts_clients" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <div class="p-col-6">
    <p-checkbox label="Importar contactos de SAGE" [(ngModel)]="integration.configuration.import_contacts_clients" binary="true" name="import_contacts_clients" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <div class="p-col-12">
    <p-checkbox label="Importar artículos de SAGE" [(ngModel)]="integration.configuration.import_articles" binary="true" name="import_articles" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <div class="p-col-12">
    <p-checkbox *ngIf="integration.configuration.import_articles" label="Importar stock acumulado de artículos de SAGE" [(ngModel)]="integration.configuration.import_articles_stock" binary="true" name="import_articles" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>

  <!--<div class="p-col-12">
    <p-checkbox label="Importar facturas de SAGE" [(ngModel)]="integration.configuration.import_invoices" binary="true" name="import_invoices" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>-->
  <div class="p-col-4 p-field" *ngIf="integration.configuration.import_invoices">
    <label>Tipo de transacción</label>
    <p-dropdown name="invoices_transaction_type_id"
                [(ngModel)]="integration.configuration.invoices_transaction_type_id"
                [options]="transactionTypes"
                (onChange)="onTransactionTypeChange()"
                optionValue="id"
                optionLabel="name"
                appendTo="body"></p-dropdown>
  </div>
  <div class="p-col-4 p-field" *ngIf="integration.configuration.import_invoices">
    <label>Estado</label>
    <p-dropdown name="invoices_transaction_status_id"
                [(ngModel)]="integration.configuration.invoices_transaction_status_id"
                [options]="transactionStatus"
                optionValue="id"
                optionLabel="name"
                appendTo="body"></p-dropdown>
  </div>

  <div class="p-col-12">
    <p-checkbox label="Exportar ventas a SAGE" [(ngModel)]="integration.configuration.export_sales" binary="true" name="export_sales" [ngModelOptions]="{standalone: true}"></p-checkbox>
  </div>
</div>

<div class="p-grid">
  <div class="p-col-12 p-d-flex">
    <div class="flex-grow-1"></div>
    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()">
    </p-button>
    <button class="p-ml-2" style="float: right;" icon="pi pi-save" pButton type="button" label="Guardar" (click)="save()"></button>
  </div>
</div>
